const Search = () => (
  <svg viewBox='0 0 20 20'>
    <path d='m15.026 13.848 3.569 3.568-1.18 1.18-3.568-3.57a7.467 7.467 0 0 1-4.68 1.641c-4.14 0-7.5-3.36-7.5-7.5 0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5a7.467 7.467 0 0 1-1.641 4.68Zm-1.672-.619A5.814 5.814 0 0 0 15 9.168a5.832 5.832 0 0 0-5.834-5.833 5.831 5.831 0 0 0-5.833 5.833A5.832 5.832 0 0 0 9.166 15a5.814 5.814 0 0 0 4.063-1.646l.125-.124Z' />
  </svg>
)

export { Search }
